import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import CustomSlaAPI from '../../api/customSla';
import AnalyticsHelper from '../../helper/AnalyticsHelper';
import { CUSTOM_SLA_EVENTS } from '../../helper/AnalyticsHelper/events';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getCustomSla(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async function get({ commit }) {
    commit(types.SET_CUSTOM_SLA_UI_FLAG, { isFetching: true });
    try {
      const response = await CustomSlaAPI.get();
      commit(types.SET_CUSTOM_SLA, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CUSTOM_SLA_UI_FLAG, { isFetching: false });
    }
  },

  create: async function create({ commit }, customSlaObj) {
    commit(types.SET_CUSTOM_SLA_UI_FLAG, { isCreating: true });
    try {
      const response = await CustomSlaAPI.create(customSlaObj);
      AnalyticsHelper.track(CUSTOM_SLA_EVENTS.CREATE);
      commit(types.ADD_CUSTOM_SLA, response.data.payload);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_CUSTOM_SLA_UI_FLAG, { isCreating: false });
    }
  },

  update: async function update({ commit }, { id, ...customSlaObj }) {
    commit(types.SET_CUSTOM_SLA_UI_FLAG, { isUpdating: true });
    try {
      const response = await CustomSlaAPI.update(id, customSlaObj);
      AnalyticsHelper.track(CUSTOM_SLA_EVENTS.UPDATE);
      commit(types.EDIT_CUSTOM_SLA, response.data.payload);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_CUSTOM_SLA_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteCustomSla({ commit }, id) {
    commit(types.SET_CUSTOM_SLA_UI_FLAG, { isDeleting: true });
    try {
      await CustomSlaAPI.delete(id);
      AnalyticsHelper.track(CUSTOM_SLA_EVENTS.DELETED);
      commit(types.DELETE_CUSTOM_SLA, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_CUSTOM_SLA_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_CUSTOM_SLA_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_CUSTOM_SLA]: MutationHelpers.set,
  [types.ADD_CUSTOM_SLA]: MutationHelpers.create,
  [types.EDIT_CUSTOM_SLA]: MutationHelpers.update,
  [types.DELETE_CUSTOM_SLA]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
